export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.langtan': '',
  'menu.langtan.home': '驾驶舱',
  'menu.langtan.home.overview': '业务总览',
  'menu.langtan.home.analysis': '业务总览',
  'menu.langtan.verification': '核销管理',
  'menu.langtan.verification.appointment': '预约记录',
  'menu.langtan.verification.reconciliation': '对账中心',
  'menu.langtan.order': '订单中心',
  'menu.langtan.order.orderList': '订单管理',
  'menu.langtan.order.payOrderList': '支付单',
  'menu.langtan.goods': '商品中心',
  'menu.langtan.goods.single': '单次卡',
  'menu.langtan.goods.multiple': '多次卡',
  'menu.langtan.goods.circle': '周期卡',
  'menu.langtan.goods.group': '组合卡',
  'menu.langtan.member': '会员管理',
  'menu.langtan.member.memberList': '会员中心',
  'menu.langtan.member.swimmerList': '游泳者列表',
  'menu.langtan.appeal': '投诉管理',
  'menu.langtan.appeal.appealList': '投诉列表',
  'menu.langtan.space': '基础设置',
  'menu.langtan.space.spaceList': '空间列表',
  'menu.langtan.space.gymList': '场馆列表',
  'menu.langtan.space.pool': '泳池管理',
  'menu.langtan.space.parking': '停车场',
  'menu.langtan.space.gate': '闸机',
  'menu.langtan.space.bandTerminal': '手环机',
  'menu.langtan.space.band': '手环',
  'menu.langtan.operating': '运营管理',
  'menu.langtan.operating.carousel': '轮播图',
  'menu.langtan.operating.announcement': '公告管理',
  'menu.langtan.operating.recommendation': '推荐管理',
  'menu.langtan.operating.notice': '运营通知',
  'menu.langtan.poolSafety': '泳池安全',
  'menu.langtan.poolSafety.cameraList': '摄像机列表',
  'menu.langtan.poolSafety.groupList': '分组列表',
  'menu.langtan.poolSafety.recognitionConfig': '识别参数配置',
  'menu.langtan.poolSafety.recognitionActionConfig': '本池行为识别配置',
  'menu.langtan.poolSafety.visionOpenCredential': '开放接口凭证',
  'menu.langtan.projectSafety': '安全配置',
  'menu.langtan.projectSafety.visionOpenCredential': '开放接口凭证',
  'menu.langtan.projectSafety.recognitionActionDict': '行为识别字典',
  'menu.langtan.poolSafety.visionHeadcountHistory': '泳道人数上报',
  'menu.langtan.poolSafety.visionModelHealthHistory': '模型健康历史',
  'menu.langtan.poolSafety.recognitionAlarmRecords': '行为上报记录',
  'menu.langtan.poolSafety.visionMediaUploadHistory': '媒体上传记录',
  'menu.langtan.poolSafety.visionStreamRegisterHistory': '流登记日志',
  'menu.langtan.poolSafety.monitorScreen': '大屏视图配置',
  'menu.langtan.poolSafety.alarmTemplate': '告警模板',
  'menu.langtan.poolSafety.alarmTest': '告警联调测试',
  'menu.langtan.poolSafety.evidenceRecording': '证据录像',
  'menu.langtan.poolSafety.alarmHandling': '告警记录',
  'menu.langtan.poolSafety.alarmMessageRecords': '消息记录',
  'menu.langtan.poolSafety.staffWorkStats': '工作统计',

  'menu.langtan.poolSafety.deviceMgmt': '设备管理',
  'menu.langtan.poolSafety.terminalDeviceList': '设备列表',
  'menu.langtan.poolSafety.deviceMonitor': '设备监控',
  'menu.langtan.poolSafety.systemLog': '系统日志',
  'menu.langtan.statistics': '统计分析',
  'menu.langtan.statistics.goods': '商品统计',
  'menu.langtan.statistics.member': '会员统计',
  'menu.langtan.statistics.order': '订单统计',
  'menu.langtan.system': '项目配置',
  'menu.langtan.system.department': '部门管理',
  'menu.langtan.system.role': '角色管理',
  'menu.langtan.system.staff': '员工管理',
  'menu.langtan.system.menu': '菜单管理',
  'menu.langtan.system.permissionVersion': '版本管理',

  'menu.dashboard': '驾驶舱',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页(Demo)',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页(Demo)',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
